/**
 * Bellabeau Tapware - Variant Card Filter
 * Hides product cards that don't match the active color filter
 */

(function() {
  'use strict';

  // Map filter group IDs to color names
  const FILTER_MAP = {
    '90308838': 'Chrome',
    '90374374': 'Matte Black',
    '90276070': 'Brushed Brass',
    '90341606': 'Gun Metal'
  };

  /**
   * Get active color filter from URL
   */
  function getActiveColorFilter() {
    const urlParams = new URLSearchParams(window.location.search);
    const colorFilter = urlParams.get('filter.v.t.shopify.color-pattern');
    
    if (!colorFilter) return null;
    
    // Extract the filter group ID from the GID
    const match = colorFilter.match(/FilterSettingGroup\/(\d+)/);
    if (match && match[1]) {
      return FILTER_MAP[match[1]] || null;
    }
    
    return null;
  }

  /**
   * Get the variant color from a product card
   * Checks the card's title, links, or selected variant
   */
  function getCardVariantColor(card) {
    // Method 1: Check the product title
    const titleElement = card.querySelector('.card__heading a, .card-information__text a, h3 a');
    if (titleElement) {
      const title = titleElement.textContent.trim();
      // Check if title contains any color name
      for (const color of Object.values(FILTER_MAP)) {
        if (title.includes(color)) {
          return color;
        }
      }
    }

    // Method 2: Check which variant radio is checked
    const checkedVariant = card.querySelector('input[type="radio"][name*="option"]:checked');
    if (checkedVariant) {
      const variantTitle = checkedVariant.getAttribute('data-title');
      if (variantTitle) {
        for (const color of Object.values(FILTER_MAP)) {
          if (variantTitle.includes(color)) {
            return color;
          }
        }
      }
    }

    // Method 3: Check the first variant option available
    const firstVariant = card.querySelector('input[type="radio"][name*="option"]');
    if (firstVariant) {
      const variantTitle = firstVariant.getAttribute('data-title');
      if (variantTitle) {
        for (const color of Object.values(FILTER_MAP)) {
          if (variantTitle.includes(color)) {
            return color;
          }
        }
      }
    }

    // Method 4: Check the product link URL for variant parameter
    const productLink = card.querySelector('a[href*="variant="]');
    if (productLink) {
      const href = productLink.getAttribute('href');
      const variantMatch = href.match(/variant=(\d+)/);
      if (variantMatch) {
        // Try to find which color this variant is by checking labels
        const allVariantInputs = card.querySelectorAll('input[type="radio"][name*="option"]');
        for (const input of allVariantInputs) {
          if (input.value === variantMatch[1]) {
            const variantTitle = input.getAttribute('data-title');
            if (variantTitle) {
              for (const color of Object.values(FILTER_MAP)) {
                if (variantTitle.includes(color)) {
                  return color;
                }
              }
            }
          }
        }
      }
    }

    return null;
  }

  /**
   * Hide or show product cards based on the active filter
   */
  function filterProductCards(activeFilter) {
    // Find all product card wrappers
    const cardWrappers = document.querySelectorAll('.adev-nc__col, .grid__item');
    
    if (!cardWrappers.length) {
      console.log('No product cards found');
      return;
    }

    console.log(`Found ${cardWrappers.length} product card wrappers`);
    console.log('Active filter:', activeFilter || 'none');

    cardWrappers.forEach((wrapper, index) => {
      const card = wrapper.querySelector('adev-product-card, .card-wrapper, .card');
      
      if (!card) {
        return;
      }

      if (!activeFilter) {
        // No filter active, show all cards
        wrapper.style.display = '';
        return;
      }

      // Get the color this card represents
      const cardColor = getCardVariantColor(card);
      console.log(`Card ${index}: ${cardColor}`);

      if (cardColor === activeFilter) {
        // This card matches the filter, show it
        wrapper.style.display = '';
      } else if (cardColor) {
        // This card is a different color, hide it
        wrapper.style.display = 'none';
      } else {
        // Couldn't determine the color, show it to be safe
        wrapper.style.display = '';
      }
    });
  }

  /**
   * Main function to apply filters
   */
  function applyVariantCardFilters() {
    const activeFilter = getActiveColorFilter();
    console.log('Applying variant card filters...');
    filterProductCards(activeFilter);
  }

  /**
   * Initialize when DOM is ready
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyVariantCardFilters);
  } else {
    applyVariantCardFilters();
  }

  // Re-run when filters change (for AJAX-loaded content)
  document.addEventListener('shopify:section:load', applyVariantCardFilters);
  
  // Watch for URL changes (if using AJAX filtering)
  let lastUrl = location.href;
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      setTimeout(applyVariantCardFilters, 300);
    }
  }).observe(document, { subtree: true, childList: true });

  // Also listen for filter changes via facets
  document.addEventListener('click', function(e) {
    if (e.target.closest('.facets__disclosure, .facet-checkbox')) {
      setTimeout(applyVariantCardFilters, 500);
    }
  });

})();